import type { CSS } from '../../stitches.config';
import { type SpacingScale, isSpacingValue } from './sizes';

export type MaxHeightTypes = 'full' | 'screen' | SpacingScale | string;
export type MaxHeightProps = { maxHeight?: MaxHeightTypes };

export const maxHeightCSS = (maxHeight?: MaxHeightTypes): CSS => {
  if (maxHeight === 'full' || maxHeight === '100%') {
    return { maxHeight: '100%' };
  }

  if (maxHeight === 'screen') {
    return { maxHeight: '100dvh' };
  }

  if (typeof maxHeight === 'number' && isSpacingValue(maxHeight)) {
    return { maxHeight: `$${maxHeight}` };
  }

  if (typeof maxHeight === 'string') {
    return { maxHeight };
  }

  return {};
};
